import Base from '../../js/_base';

export default class ClientPagination extends Base {
    wrapperTable;

    wrapperPagination;

    get showPerPage() {
        return parseInt(this._elements.showPerPage.value, 0);
    }

    get pagesDisplayed() {
        return parseInt(this._elements.pagesDisplayed.value, 0);
    }

    get pageCaption() {
        return this._elements.containerName?.dataset.pageCaption;
    }

    get selectors() {
        return {
            containerName: '.client-pagination',
            pagination: '.pagination',
            pages: '.pages',
            pageItemArrowPrev: '.page-item__arrow--prev',
            pageItem: '.page-item',
            pageItemArrowNext: '.page-item__arrow--next',
            pageLink: '.page-link',
            currentPage: '.current-page',
            showPerPage: '.show-per-page',
            pagesDisplayed: '.pages-displayed',
            tableRow: '.table-data-row',
            firstPage: '[data-page-index="0"]',
        };
    }

    get elements() {
        return {
            containerName: null,
            showPerPage: null,
            currentPage: null,
            pagesDisplayed: null,
            tableRows: null,
            pageItemArrowPrev: null,
            pageItemArrowNext: null,
            pages: null,
        };
    }

    get classList() {
        return {
            displayBlock: 'd-block',
            displayFlex: 'd-flex',
            displayNone: 'd-none',
            pageItem: 'page-item',
            page: 'page',
            pageLinkClasses: 'page-link d-flex align-items-center justify-content-center',
        };
    }

    constructor(wrapper, pagination) {
        super();
        this.wrapperTable = wrapper;
        this.wrapperPagination = pagination;
    }

    initialize() {
        super.initialize();
        this._elements.containerName = this.wrapperPagination.querySelector(this._selectors.containerName);
        // paginator elements
        this._elements.pages = this._elements.containerName.querySelector(this._selectors.pages);
        this._elements.showPerPage = this._elements.containerName.querySelector(this._selectors.showPerPage);
        this._elements.currentPage = this._elements.containerName.querySelector(this._selectors.currentPage);
        this._elements.pagesDisplayed = this._elements.containerName.querySelector(this._selectors.pagesDisplayed);
        this._showPerPage = this.showPerPage;
        this._pagesDisplayed = this.pagesDisplayed;
        this._pageCaption = this.pageCaption;
        this._elements.pageItemArrowPrev = this._elements.containerName.querySelector(
            this._selectors.pageItemArrowPrev
        );
        this._elements.pageItemArrowNext = this._elements.containerName.querySelector(
            this._selectors.pageItemArrowNext
        );

        this.buildPagination();
        this.addEventListeners();
    }

    addEventListeners() {
        super.addEventListeners();
        this._elements.pageItemArrowPrev.addEventListener('click', this.previous.bind(this));
        this._elements.pageItemArrowNext.addEventListener('click', this.next.bind(this));
        this._elements.containerName.addEventListener('click', e => {
            if (e.target.classList.contains(this._classList.page)) {
                e.preventDefault();
                this.goToPage(parseInt(e.target.dataset.pageIndex));
            }
        });
    }

    buildPagination() {
        // table elements
        this._elements.tableRows = this.wrapperTable.querySelectorAll(this._selectors.tableRow);
        let items = this._elements.tableRows;
        const numberOfItems = items.length;
        const numberOfPages = Math.ceil(numberOfItems / this._showPerPage);
        this._elements.containerName.querySelectorAll(this._selectors.pageItem).forEach(pageItem => {
            pageItem.remove();
        });
        if (numberOfItems > this._showPerPage) {
            items.forEach(item => {
                item.classList.remove(this._classList.displayFlex);
                item.classList.add(this._classList.displayNone);
            });
            items = this.convertToArray(items).slice(0, this._showPerPage);
            items.forEach(item => {
                item.classList.remove(this._classList.displayNone);
            });
            this._elements.pageItemArrowPrev.classList.add(this._classList.displayNone);
            this._elements.pageItemArrowNext.classList.add(this._classList.displayBlock);
            let i = 0;
            this._elements.pages.innerHtml = '';
            const generatePageItem = visibility => {
                const pageItemEl = `<li class="${this._classList.pageItem} ${visibility}"><a class="${
                    this._classList.page
                } ${this._classList.pageLinkClasses}" href="#" aria-label="${this._pageCaption + (i + 1)}" title="${
                    this._pageCaption + (i + 1)
                }" data-page-index="${i}">${i + 1}</a></li>`;
                this._elements.pages.appendChild(this.stringToNode(pageItemEl));
            };
            while (i < numberOfPages) {
                if (i >= this._pagesDisplayed) {
                    // to do
                    generatePageItem('d-none');
                } else {
                    generatePageItem('');
                }
                i++;
            }
            this._elements.containerName.querySelector(this._selectors.firstPage).parentElement.classList.add('active');
        } else {
            this._elements.containerName.style.display = 'block';
        }
    }

    goToPage(pageNum) {
        let items = this._elements.tableRows;
        const numberOfItems = items.length;
        const numberOfPages = Math.ceil(numberOfItems / this._showPerPage);
        const startFrom = pageNum * this._showPerPage;
        const endOn = startFrom + this._showPerPage;
        const currentPage = this._elements.containerName.querySelector(
            '[data-page-index="' + pageNum + '"]'
        )?.parentElement;
        items.forEach(item => {
            item.classList.remove(this._classList.displayFlex);
            item.classList.add(this._classList.displayNone);
        });
        items = this.convertToArray(items).slice(startFrom, endOn);
        items.forEach(item => {
            item.classList.remove(this._classList.displayNone);
        });
        this._elements.currentPage.value = pageNum;
        this._elements.containerName.querySelectorAll(this._selectors.pageItem).forEach(pageItem => {
            pageItem.classList.remove('active');
            pageItem.classList.remove(this._classList.displayFlex);
            pageItem.classList.add(this._classList.displayNone);
        });
        currentPage.classList.add('active');
        const showPagesBeforeAfter = Math.ceil(this._pagesDisplayed / 2);
        const showPageItem = i => {
            const el = this._elements.containerName.querySelector(`[data-page-index="${i}"]`)?.parentElement;
            el?.classList.remove(this._classList.displayNone);
        };
        if (pageNum + 1 > showPagesBeforeAfter) {
            for (let i = pageNum + 1 - showPagesBeforeAfter; i < pageNum + showPagesBeforeAfter; i++) {
                if (i <= numberOfPages) {
                    showPageItem(i);
                }
            }
        } else {
            for (let i = 0; i < this._pagesDisplayed; i++) {
                showPageItem(i);
            }
        }

        // Hide/Show next prev
        if (pageNum === 0) {
            this._elements.pageItemArrowPrev.classList.remove(this._classList.displayBlock);
            this._elements.pageItemArrowPrev.classList.add(this._classList.displayNone);
            this._elements.pageItemArrowPrev.querySelector(this.selectors.pageLink).setAttribute('rel', 'nofollow');
        } else {
            this._elements.pageItemArrowPrev.classList.remove(this._classList.displayNone);
            this._elements.pageItemArrowPrev.classList.add(this._classList.displayBlock);
            this._elements.pageItemArrowPrev.querySelector(this.selectors.pageLink).removeAttribute('rel');
        }

        if (pageNum === numberOfPages - 1) {
            this._elements.pageItemArrowNext.classList.remove(this._classList.displayBlock);
            this._elements.pageItemArrowNext.classList.add(this._classList.displayNone);
            this._elements.pageItemArrowNext.querySelector(this.selectors.pageLink).setAttribute('rel', 'nofollow');
        } else {
            this._elements.pageItemArrowNext.classList.remove(this._classList.displayNone);
            this._elements.pageItemArrowNext.classList.add(this._classList.displayBlock);
            this._elements.pageItemArrowNext.querySelector(this.selectors.pageLink).removeAttribute('rel');
        }
    }

    previous(e) {
        e.preventDefault();
        const newPage = parseInt(this._elements.currentPage.value, 0) - 1;
        if (newPage > -1) {
            this.goToPage(newPage);
        }
    }

    next(e) {
        e.preventDefault();
        const newPage = parseInt(this._elements.currentPage.value, 0) + 1;
        const numberOfItems = this._elements.tableRows.length;
        const numberOfPages = Math.ceil(numberOfItems / this._showPerPage);
        if (newPage < numberOfPages) {
            this.goToPage(newPage);
        }
    }
}
